import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'
import cx from 'classnames'

import { Link } from '@/components/common'
import TopNavButton from '@/components/layout/TopNavButton'
import TryFreeCta from '@/components/TryFreeCta'
import { URLS } from '@/constants'
import routes from '@/routes'
import headerLogoImg from '@/assets/header-logo.svg'
import WebAppLink from '@/components/common/WebAppLink'

import MobileHeaderNav from './MobileHeaderNav'
import styles from './Header.module.scss'

const mainNavItems = [
  {
    name: 'product',
    to: '#',
    menu: [
      { name: 'neatFeatures' },
      { name: 'automatedInsights' },
      { name: 'vipService' },
    ],
  },
  {
    name: 'features',
    to: '#',
    menu: [
      { name: 'trackReceipts' },
      { name: 'expenseManagementMobileApp' },
      { name: 'taxPrep' },
      { name: 'digitalFilingCabinet' },
      { name: 'transactionStreaming' },
      { name: 'integrations' },
      { name: 'security' },
      { name: 'receiptDocumentScanners' },
    ],
  },
  { name: 'pricing' },
  {
    name: 'learn',
    to: '#',
    menu: [
      { name: 'blog' },
      { name: 'newsletter' },
      { name: 'webinars' },
      { name: 'helpCenter', to: URLS.support.home, external: true },
      { name: 'receiptsExpensesTaxesGuide' },
    ],
  },
]

export default function Header({ logoOnly, className }) {
  return (
    <div className={cx(styles.header, className)}>
      <div className={styles.content}>
        <Link className={styles.logo} to={routes.index}>
          <Image
            alt="Neat"
            height={24}
            src={headerLogoImg}
            style={{ maxWidth: '140px' }}
            width={92}
          />
        </Link>
        {logoOnly ||
        <>
          <div className={styles.nav}>
            {mainNavItems.map(item => <TopNavButton key={item.name} {...item} />)}
            <WebAppLink
              eventTrackingProperties={{ location: 'App Header' }}
              round={false}
              variant="secondary"
            />
            <TryFreeCta
              data-testid="header-try-neat-free"
              messageId="cta.tryNeatFREE"
              round={false}
              size="medium"
            />
          </div>
          <div className={styles.mobileHeaderNav}>
            <MobileHeaderNav items={mainNavItems} />
          </div>
        </>}
      </div>
    </div>
  )
}

Header.propTypes = {
  logoOnly: PropTypes.bool,
  className: PropTypes.string,
}
